var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-container" },
    [
      _c(
        "form-wrapper",
        { staticClass: "modal-form", attrs: { validator: _vm.$v.rateDetail } },
        [
          _c("header", { staticClass: "modal-header" }, [
            _c(
              "div",
              { staticClass: "modal-header__right" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-simple md-just-icon md-round",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$modal.hide($event)
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("clear")])],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("section", { staticClass: "modal-section" }, [
            _c("div", { staticClass: "section-heading" }, [
              _c(
                "div",
                { staticClass: "section-override" },
                [
                  _c(
                    "md-switch",
                    {
                      model: {
                        value: _vm.rateDetail.overrideRule,
                        callback: function ($$v) {
                          _vm.$set(_vm.rateDetail, "overrideRule", $$v)
                        },
                        expression: "rateDetail.overrideRule",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Override\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("span", { staticClass: "section-heading__badge" }, [
                _vm._v("Timeframe"),
              ]),
              _c("p", { staticClass: "section-heading__copy" }, [
                _vm._v("Choose when the rule is active."),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "section-card section-card--wide" },
              [
                _c("rule-valid-days", {
                  ref: "ruleValidDays",
                  attrs: {
                    "current-days": _vm.rateDetail.validForWeekDays,
                    "from-date": _vm.rateDetail.validFromDate,
                    "to-date": _vm.rateDetail.validToDate,
                  },
                  on: { daysSelected: _vm.handleDaysSeleceted },
                }),
              ],
              1
            ),
          ]),
          _c("section", { staticClass: "modal-section" }, [
            _c("div", { staticClass: "section-heading" }, [
              _c("span", { staticClass: "section-heading__badge" }, [
                _vm._v("Charging"),
              ]),
              _c("p", { staticClass: "section-heading__copy" }, [
                _vm._v("Set flag fall, interval pricing and inclusions."),
              ]),
            ]),
            _c("div", { staticClass: "section-card section-card--compact" }, [
              _c("div", { staticClass: "charging-grid" }, [
                _c(
                  "div",
                  { staticClass: "charging-group" },
                  [
                    _c("h5", { staticClass: "charging-group__title" }, [
                      _vm._v("Flag fall"),
                    ]),
                    _c("p", { staticClass: "charging-group__hint" }, [
                      _vm._v(
                        "Optional one-off amount before interval billing begins."
                      ),
                    ]),
                    _c(
                      "form-group",
                      { attrs: { name: "weightFlagfall", label: "Flag Fall" } },
                      [
                        _vm.$_nullChecker(_vm.rateDetail.weightFlagfall)
                          ? _c("rule-operator", {
                              attrs: {
                                value: _vm.rateDetail.weightFlagfall.operator,
                              },
                              model: {
                                value: _vm.rateDetail.weightFlagfall.operator,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.rateDetail.weightFlagfall,
                                    "operator",
                                    $$v
                                  )
                                },
                                expression:
                                  "rateDetail.weightFlagfall.operator",
                              },
                            })
                          : _vm._e(),
                        _c("md-input", {
                          model: {
                            value: _vm.rateDetail.weightFlagfall.value,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.rateDetail.weightFlagfall,
                                "value",
                                _vm._n($$v)
                              )
                            },
                            expression: "rateDetail.weightFlagfall.value",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", {
                  staticClass: "charging-separator",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("div", { staticClass: "charging-group" }, [
                  _c("h5", { staticClass: "charging-group__title" }, [
                    _vm._v("Intervals"),
                  ]),
                  _c("p", { staticClass: "charging-group__hint" }, [
                    _vm._v("Breakpoints that trigger per weight pricing."),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-pair" },
                    [
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "weightInterval",
                            label: "Weight Interval",
                          },
                        },
                        [
                          _vm.$_nullChecker(_vm.rateDetail.weightInterval)
                            ? _c("rule-operator", {
                                attrs: {
                                  value: _vm.rateDetail.weightInterval.operator,
                                },
                                model: {
                                  value: _vm.rateDetail.weightInterval.operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.weightInterval,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.weightInterval.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value: _vm.rateDetail.weightInterval.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.weightInterval,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression: "rateDetail.weightInterval.value",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "weightRatePerInterval",
                            label: "Charge Per Interval",
                          },
                        },
                        [
                          _vm.$_nullChecker(
                            _vm.rateDetail.weightRatePerInterval
                          )
                            ? _c("rule-operator", {
                                attrs: {
                                  value:
                                    _vm.rateDetail.weightRatePerInterval
                                      .operator,
                                },
                                model: {
                                  value:
                                    _vm.rateDetail.weightRatePerInterval
                                      .operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.weightRatePerInterval,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.weightRatePerInterval.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value: _vm.rateDetail.weightRatePerInterval.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.weightRatePerInterval,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "rateDetail.weightRatePerInterval.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", {
                  staticClass: "charging-separator",
                  attrs: { "aria-hidden": "true" },
                }),
                _c("div", { staticClass: "charging-group" }, [
                  _c("h5", { staticClass: "charging-group__title" }, [
                    _vm._v("Inclusions"),
                  ]),
                  _c("p", { staticClass: "charging-group__hint" }, [
                    _vm._v("Define included weight and minimum charges."),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-pair" },
                    [
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "includedWeight",
                            label: "Included Weight",
                          },
                        },
                        [
                          _vm.$_nullChecker(_vm.rateDetail.includedWeight)
                            ? _c("rule-operator", {
                                attrs: {
                                  value: _vm.rateDetail.includedWeight.operator,
                                },
                                model: {
                                  value: _vm.rateDetail.includedWeight.operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.includedWeight,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.includedWeight.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value: _vm.rateDetail.includedWeight.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.includedWeight,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression: "rateDetail.includedWeight.value",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "weightMinimumCharge",
                            label: "Minimum Charge",
                          },
                        },
                        [
                          _vm.$_nullChecker(_vm.rateDetail.weightMinimumCharge)
                            ? _c("rule-operator", {
                                attrs: {
                                  value:
                                    _vm.rateDetail.weightMinimumCharge.operator,
                                },
                                model: {
                                  value:
                                    _vm.rateDetail.weightMinimumCharge.operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.weightMinimumCharge,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.weightMinimumCharge.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value: _vm.rateDetail.weightMinimumCharge.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.weightMinimumCharge,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "rateDetail.weightMinimumCharge.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("footer", { staticClass: "modal-footer" }, [
            _c(
              "div",
              { staticClass: "modal-footer__actions" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-default dialog-button",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$modal.hide($event)
                      },
                    },
                  },
                  [_vm._v("Cancel")]
                ),
                _c(
                  "md-button",
                  {
                    staticClass: "md-primary dialog-button",
                    on: {
                      click: function ($event) {
                        return _vm.create()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.isUpdate ? "Update" : "Create") +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }